<template>
<div id="ServiceCodePrereqServiceCodesAddEdit"> 
<form> 
<div class="form-group row my-1">

    <label for="ServiceCode" class="col-sm-4 label-small my-0">Search Service Code:</label>
        <div class="col-sm-8 my-0">
            <vue-bootstrap-typeahead ref="searchbox" :disableSort=true  v-model="ServiceCodePick"  @input="ServiceCodeChange"  :data="ServiceCodes"  @hit="ServiceCodeChange(SelectedCode = $event)"
                :serializer="item => item.servicedesc"  textVariant=".text-info"   placeholder="Search Service Code"  size="sm"  backgroundVariant="bg-light" :maxMatches="20" >
                <template slot="prepend">
                    <span class="input-group-text" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                </template>                      
            </vue-bootstrap-typeahead> 
        <!-- <div v-if="this.ServiceCodePick.length"> {{this.codeServiceContradictory}} ({{this.serviceCodeDesc}})</div> -->
       
        </div>

</div>

 
    <div class="form-group row" v-if="$v.codeServiceContradictory.$error" > 
     <small class="sml-red col-sm-4"> </small>
         <small class="sml-red col-sm-2 ml-3" v-if="!$v.codeServiceContradictory.required">Service Code is required</small>
         <small class="sml-red col-sm-3" v-if="!$v.codeServiceContradictory.Duplicate">Service Code already added</small>         
         <small class="sml-red col-sm-3" v-if="!$v.IsContraAllow">Service Code can't contradict itself</small>
    </div>

<div class="form-group row my-1">

    <label for="ServiceCode" class="col-sm-2 label-small my-0">Selected Service Code:</label>
     <button :disabled="!IsDental" v-on:click="SetSelfContra"   type="button" class="col-sm-2 label-small my-0 btn btn-sml btn-primary">Self Contradict <i class="ml-2 fa fa-share-square" aria-hidden="true"></i></button> 
    <div class="col-sm-8 my-0">
  
    <div v-if="this.codeServiceContradictory"><b>{{this.codeServiceContradictory}} ({{this.serviceCodeDesc}})</b></div>
    
    </div>

</div>
     
<div class="form-group row my-1">
    <label for="ExtraInfo" class="col-sm-4 label-small my-0">Extra Info:</label>
    <div class="col-sm-4 my-0">
        <select  id="ExtraInfo"  v-model="codeDescDental"  class="mb-1 form-control form-control-sm"> 
            <option v-for="option  in ExtraInfo" v-bind:value="{id: option.id,text:option.text}" :key="option.id" class="small">
                {{ option.text }}
            </option> 
        </select>
    </div>
</div>
<div class="form-group row" v-show="$v.codeDescDental.$error" > 
    <small class="sml-red col-sm-4"> </small>
    <small class="sml-red col-sm-4 ml-3" v-if="!$v.codeDescDental.needValue">Extra info is required</small>
</div>
<div class="form-group row my-1">
    <label for="codeUnitContradictory" class="col-sm-4 label-small my-0">Exclusivity Unit:</label>
    <div class="col-sm-4 my-0">
        <select  id="codeUnitContradictory"  v-model="codeUnitContradictory"  class="mb-1 form-control form-control-sm"> 
            <option v-for="option  in DurationCodes" v-bind:value="{id: option.id,text:option.text}" :key="option.id" class="small">
                {{ option.text }}
            </option> 
        </select>
    </div>
</div>
     <div class="form-group row my-1">
    <label for="numUnitConradictory" class="col-sm-4 label-small my-0">Exclusivity Length:</label>
    <div class="col-sm-4 my-0">
        <input id="numUnitConradictory"   maxlength="3" v-model="numUnitConradictory" placeholder="Exclusivity Period" class="mb-0 form-control form-control-xs">
    </div>
</div> 
<div class="form-group row" v-show="$v.numUnitConradictory.$error" > 
    <small class="sml-red col-sm-4"> </small>
    <small class="sml-red col-sm-4 ml-3" v-if="!$v.numUnitConradictory.required">Duration Length is required</small>
    <small class="sml-red col-sm-4 " v-if="!$v.numUnitConradictory.numeic && $v.numUnitConradictory.required">Duration Length must be a number</small>
</div> 
<hr>
<div class="row" >
    <div class="col-sm-8" >
            <button v-on:click="SavePopup" :disabled="disableSave" type="button" class="btn BtnSave  btn-sml"><i :class="saveIcon"></i> {{btnName}} </button>
    </div>
    <div class="col-sm-4">
        <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
    </div>
</div> 
</form>
</div>

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'

Vue.use(Vuelidate)

import { required,sameAs, minLength, maxLength, between,withParams,email,numeric} from 'vuelidate/lib/validators'
import { notEqual } from 'assert'; 
export default {
    props:{
        UserData:'',
        Codes:'',
        mode:'',
        DataSet:'',
        UserRow:'',
        CurrentCode:'',
        CurrentCodeDesc:''
    },
  data: function(){
    return{
       
        ServiceCodePick:'',
        IsContraAllow:true,
        IsDental : false,
        saveIcon:'fas fa-plus',
        btnName: 'Add Contradictory Service Codes',
        numUnitDelay:'',
        codeServiceContradictory:'',
        codeUnitContradictory:'',
        numUnitConradictory:'',
        serviceCodeDesc:'',
        succeeded:true,
        showModal:false,
        showModal:false,
        Msg:'',
        EditMode:'',
        disableSave:false,
        updateRow:{
            codeDescDental:'',
            codeServiceContradictory:'',
            codeUnitContradictory:'',
            numUnitConradictory:''
        },
        ServiceCodes:[], 
        SelectedCode:'',
        serviceids:[],
        ExtraInfo : [{id:'TOOTH', text :'TOOTH'},{id:"QUADRANT", text :'QUADRANT'},{id:"ARCH", text :'ARCH'},{id:'    ', text:'NONE'}],
        DurationCodes : [{id: 'D', text:'Days'},{id:'M', text:'Months'},{id:'Y', text:'Years'},{id:'L', text:'Lifetime'}],
        codeDescDental : '',
        tabledata:'',
        editedRow:'',
        serviceCode:'',
    }   
  },
  created: function(){
     /// console.log('this contra desc' + this.UserData.codeDescDental)
    //  this.ExtraInfo = [{id:'TOOTH'},{id:"QUADRANT"},{id:"ARCH"},{id:'NONE', text:'NONE'}];
     // this.DurationCodes = [{id: 'D', text:'Days'},{id:'M', text:'Months'},{id:'Y', text:'Years'},{id:'L', text:'Lifetime'}];
      this.codeDescDental = this.UserData.codeDescDental==undefined?undefined:this.ExtraInfo.find(x=>x.id== this.UserData.codeDescDental.trim());
      //console.log('this contra desc after' + this.codeDescDental.id )
        console.log( ' Unit code delay  before  ' + this.UserData.codeUnitContradictory )
      this.codeServiceContradictory = this.UserData.codeServiceContradictory==undefined?'':this.UserData.codeServiceContradictory;
      this.codeUnitContradictory =this.UserData.codeUnitContradictory==undefined?{id:'M',text:'Months'}: this.DurationCodes.find(x=>x.id== this.UserData.codeUnitContradictory);
        console.log( ' Unit code delay  after ' + this.codeUnitContradictory )
      this.numUnitConradictory = this.UserData.numUnitConradictory;

      this.EditMode = this.mode;
        
      for(var i=0;i< this.Codes.length;i++){
            this.serviceids.push(this.Codes[i].id);
            console.log('at add edit service ids' + this.serviceids)
      }

      if(this.serviceids!=undefined > 0)
        this.GetServiceCodes();

      if(this.EditMode  == 'Edit')
      {
          this.btnName = 'Edit Prerequisite Service Codes';
          this.saveIcon = 'far fa-edit'; 
      } 
      this.tabledata = this.DataSet;
      this.editedRow = this.UserRow;
      this.serviceCode = this.CurrentCode;
      console.log('current Sc=' + this.serviceCode)
      console.log('Contra Sc=' + this.codeServiceContradictory)

      if(this.serviceids !=undefined && this.serviceids !=null)
      {
          if(this.serviceids.includes(1))
          {
              //if(this.codeServiceContradictory != this.serviceCode)
              this.IsDental = true;
              console.log('Allow Contra')
          }
          else
          {
              //if(this.codeServiceContradictory == this.serviceCode)
              this.IsDental = false;
          }
          
      } 

  },

methods: {
    SetSelfContra()

    {
        this.codeServiceContradictory=this.serviceCode;
        this.serviceCodeDesc =this.CurrentCodeDesc;

    },
    ServiceCodeChange()
    {
     if (this.ServiceCodePick == '' || this.ServiceCodePick == null) {
        this.SelectedCode = '';
         console.log(' V-model Sc ' +this.ServiceCodePick)
      }
    },
  ClosePopup: function() {     
      this.$root.$emit('bv::hide::modal', 'ServiceCodePrereqServiceCodesAddEdit', '#btnShow') 
         //this.$v.$reset();
    },
    SavePopup: function(){
        console.log( 'at conteadictory code unidelay is = ' +this.codeUnitContradictory.id)
        //console.log(this.$v)
        this.$v.$touch();
        
        if (!this.$v.$invalid){
            this.updateRow.codeDescDental = this.codeDescDental.id;
            this.updateRow.codeServiceContradictory = this.codeServiceContradictory;
            this.updateRow.codeUnitContradictory = this.codeUnitContradictory.id;
            this.updateRow.numUnitConradictory = this.numUnitConradictory;
            //console.log(this.updateRow);
            this.$emit('ContradictoryUpdate', this.updateRow)
            this.showModal=false;
        }

      
    },
        GetServiceCodes(){ 
           var vm = this;
           var sc= vm.codeServiceContradictory.trim();
            var params = new URLSearchParams();
            // alert(this.serviceids);
             params.append('ServiceID', this.serviceids);
             axios.get('SaskHealthApi/Codes/GetServiceCode', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
             .then(function (response) {
                    vm.ServiceCodes =response.data; 
                })
            .catch(function (er) {
                console.log(er)
            }).then(function(){

                
                // var code = vm.ServiceCodes.find(x=>x.servicecode ==vm.codePrerequisite)
                // console.log(vm.ServiceCodes)
               if(vm.codeServiceContradictory!='')
                   vm.serviceCodeDesc =  vm.ServiceCodes.find(x=>x.servicecode ==sc).servicedesc;
                vm.codeServiceContradictory =sc;
            });
        },
        ServiceCodeChange(value){
            console.log('at change' + value);
            this.codeServiceContradictory = value.servicecode;
            this.serviceCodeDesc = value.servicedesc;
        },
        AllowContraSc()
        {
            console.log('i m here')
            if(this.IsDental)
            {
                console.log('i am here dental ' + this.SelectedCode.servicecode)
                return true;
            }
            //else if(!this.IsDental && (this.tabledata.findIndex(x=>x.codeServiceContradictory == this.SelectedCode.servicecode) == -1))
            //this.serviceCode
            else if(!this.IsDental && (this.serviceCode == this.SelectedCode.servicecode))
            {
                console.log('NO dental & Equal = ' + this.SelectedCode.servicecode)
                return  false;
            }
            else if(!this.IsDental && (this.serviceCode !== this.SelectedCode.servicecode))
            {
                console.log('NO dental &  NO Equal ' + this.SelectedCode.servicecode)
                return  true;
            }
            else
            {
                console.log('Nothing found');
                return true;
            }
        },
        IsDuplicateExist()
        {
            if(this.tabledata.findIndex(x=>x.codeServiceContradictory == this.SelectedCode.servicecode) == -1)
            {
                console.log('Duplicate NOT found');
                return true;
            }
            else
            {
                console.log('Duplicate Yes ');
                return false;
            }
        }
},
  validations(){
    return {
        numUnitConradictory:{
            required,
            numeric
        },
        codeServiceContradictory:{
            required, $autoDirty: true ,
            //Duplicate: value=> this.tabledata.findIndex(x=>x.codeServiceContradictory == this.codeServiceContradictory)== -1 || this.tabledata.findIndex(x=>x.codeServiceContradictory == this.codeServiceContradictory) == this.editedRow,
            Duplicate: value=>this.IsDuplicateExist(),// (this.tabledata.findIndex(x=>x.codeServiceContradictory == this.SelectedCode.servicecode) == -1) ? true: false ,
            //isNotSameAs: value=>(this.codeServiceContradictory === this.serviceCode)
            IsContraAllow: value=>this.AllowContraSc()
            
        },
        codeDescDental:{
            needValue: value=> this.codeDescDental != undefined
        }
    }
  }
}
</script>

<style>

</style>
